import { Component, computed, input, output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DatatableSelectionFilter } from '../../types/datatable-configuration';

@Component({
  selector: 'table-datatable-saved-filter-select',
  templateUrl: './datatable-saved-filter-select.component.html',
  styleUrls: ['./datatable-saved-filter-select.component.scss'],
  imports: [MatFormFieldModule, MatSelectModule],
})
export class DatatableSavedFilterSelectComponent {
  filters = input<DatatableSelectionFilter[]>([]);
  value = input<number | undefined>(undefined);

  selectedLabel = computed(
    () =>
      this.filters().find((filter) => filter.id === this.value())?.label ?? 'Select saved filter',
  );

  valueChange = output<number>();

  onSelectionChange(value: number) {
    this.valueChange.emit(value);
  }
}
